import HistoireDelaMaladie from '@/views/consultations/en-cours/histoire-de-la-maladie'
import Constantes from '@/views/consultations/en-cours/constantes'
import MotifHistoire from '@/views/consultations/en-cours/motif-histoire';
import ExamenClinique from '@/views/consultations/en-cours/examen-clinique';
import HypotheseDiagnostic from '@/views/consultations/en-cours/hypothese-diagnostic';
import ExamenBio from '@/views/consultations/en-cours/examen-bio';
import ExamenPara from '@/views/consultations/en-cours/examen-para';
import Diagnostic from '@/views/consultations/en-cours/diagnostics';
import DHIS2Diagnostics from '@/views/consultations/en-cours/dhis2-diagnostics'
import OrdonnanceMedicale from '@/views/consultations/en-cours/ordonnance-medicale';
import Grossesse from '@/views/consultations/en-cours/grossesse'
import ExamenFemmeEnceinte from '@/views/consultations/en-cours/grossesse/examen-physique-fe'
import AcuiteVisuelle from '@/views/consultations/en-cours/ophtalmologie/acuite-visuelle'
import OrdonnaceDeLunettes from '@/views/consultations/en-cours/ophtalmologie/ordonnance-lunettes'
import CertificatsMedicaux from '@/views/consultations/en-cours/certificats-medicaux'

const composants = {
    anamnese: HistoireDelaMaladie,
    constante: Constantes,
    motif_consultation: MotifHistoire,
    examen_clinique: ExamenClinique,
    hypothese_diagnostique: HypotheseDiagnostic,
    analyse_biologique: ExamenBio,
    imagerie_medicale: ExamenPara,
    diagnostic: Diagnostic,
    dhis2_diagnostics: DHIS2Diagnostics,
    ordonnance: OrdonnanceMedicale,
    grossesse: Grossesse,
    examen_femme_enceinte: ExamenFemmeEnceinte,
    acuite_visuelle: AcuiteVisuelle,
    ordonnance_lunettes: OrdonnaceDeLunettes
}

export function composantNatif(section) {
    if (section.slug === 'dhis2_diagnostics') return DHIS2Diagnostics
    if (Number(section.is_certif_type) === 1) return CertificatsMedicaux
    return Number(section.has_field) === 0 ? composants[section.slug] : null
}
